import PropTypes from "prop-types";
import React, { Component } from "react";
import { titleTemplate } from "utils/seoUtils";
import { SportHomePageContent } from "../../Common/pages/SportHomePageContent";

export default class FootballHomePage extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="football"
      title="Football News & Scores | Betting Tips & Transfers"
      location={ location }
      helmetProps={ {titleTemplate: titleTemplate.plain} }
      rightColumnContent={ ["mostReadFootball", "topMpu", "footballTips", "ocWidget"] }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballHomePage.js